import { getPasskeyRegistrationCurrentStep, getSessionId, getAuthXToken } from '@/services/auth'
import { NR_ABANDON_PASSKEY_REGISTRATION, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks passkey registration abandonment in New Relic.
 * Records when a user abandons the passkey registration process.
 */
export const nrAbandonPasskeyRegistration = (): boolean => {
  try {

    const authxToken = getAuthXToken()

    if (authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const step = getPasskeyRegistrationCurrentStep()

    const newrelic: any = (window as any).newrelic

    // if user encountered an error or abandon during passkey registration
    if (newrelic && sessionId) {
      newrelic.addPageAction(NR_ABANDON_PASSKEY_REGISTRATION, { sessionId, step })
      return true
    }

    return false
  } catch {
    return false
  }
}
